import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Modal } from "../components/elements";
import { useAuth } from "../context/AuthContext";

export default function Header({ atTop, filled }) {
  const { user, logout } = useAuth();
  const query = new URLSearchParams(useLocation().search);
  const category = query.get("category");
  const history = useHistory();

  const [openModal, setOpenModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleLogout = () => {
    const res = logout();
    setOpenModal(false);
    if (res) {
      history.replace("/");
    }
  };

  return (
    <div
      className={`md:p-12 p-6 fixed w-full top-0 transition duration-500 ease-in-out z-40 text-white ${
        filled ? "bg-black" : atTop ? "bg-transparent " : "bg-black "
      }`}
    >
      <div className="flex justify-center md:justify-between">
        <ul className="hidden md:flex">
          <li className="mx-3 cursor-pointer hover:underline">Nigeria</li>
          <li className="mx-3 cursor-pointer hover:underline">English</li>
          <li className="mx-3 cursor-pointer hover:underline">Help</li>
        </ul>

        <Link to="/">
          <h2 className="text-3xl font-semibold">ODARA</h2>
        </Link>
        {showSignupModal || showLoginModal ? (
          <div
            className="fixed bg-opacity-40 top-0 left-0 bg-black w-screen h-screen"
            onClick={() => {
              setShowLoginModal(false);
              setShowSignupModal(false);
            }}
          ></div>
        ) : null}
        <ul className="hidden md:flex">
          {!Object.keys(user).length ? (
            <>
              <li
                className="mx-3 cursor-pointer relative"
                onClick={() => setShowSignupModal(true)}
              >
                Sign up
                {showSignupModal ? (
                  <div className="px-6 py-4  bg-white absolute -left-4 mt-2 rounded-md text-black">
                    <ul>
                      <li className="pb-2 hover:underline">
                        <Link to="/signup">Buyer</Link>
                      </li>
                      <li className="pb-2 hover:underline">
                        <Link to="/vendor-signup">Seller</Link>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </li>
              <li
                className="mx-3 cursor-pointer relative"
                onClick={() => setShowLoginModal(true)}
              >
                Sign in
                {showLoginModal ? (
                  <div className="px-6 py-4  bg-white absolute -left-4 mt-2 rounded-md text-black">
                    <ul>
                      <li className="pb-2 hover:underline">
                        <Link to="/login">Buyer</Link>
                      </li>
                      <li className="pb-2 hover:underline">
                        <Link to="/vendor-login">Seller</Link>
                      </li>
                    </ul>
                  </div>
                ) : null}
              </li>
            </>
          ) : (
            <li className="mx-3 cursor-pointer hover:underline">
              <i className="fas fa-shopping-cart">&nbsp;</i>
              <Link to="/cart"> Cart</Link>
            </li>
          )}
          {Object.keys(user).length ? (
            <li className="mx-3 flex items-center gap-2 -mt-3">
              <span className="">Hi, {user?.user_name}</span>
              <div class="dropdown dropdown-end">
                <div tabindex="0" className="avatar mt-2">
                  <div className="rounded-full w-6 h-6">
                    <img
                      className="w-6 h-6"
                      alt={user?.user_name}
                      src="/assets/blank.jpg"
                    />
                  </div>
                </div>
                <ul
                  tabindex="0"
                  class="p-2 shadow menu dropdown-content bg-base-100 rounded-box w-36"
                >
                  <li>
                    <button
                      onClick={() => setOpenModal(true)}
                      className="btn btn-ghost text-primary"
                    >
                      <i class="fas fa-sign-out-alt"></i>&nbsp; Log out
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
      <ul className="flex md:justify-center mt-6 overflow-x-scroll md:overflow-x-auto">
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "clothing"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=clothing">clothing </Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "jewelry"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=jewelry">jewelry</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "fabrics"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=fabrics">fabrics</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "accessory"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=accessory">accessory</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "art"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=art">art</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "craft"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=craft">craft</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "gifts"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=gifts">gifts</Link>
        </li>
        <li
          className={`mx-3 cursor-pointer hover:underline uppercase ${
            category?.toLowerCase() === "more"
              ? "underline text-primary font-bold"
              : null
          }`}
        >
          <Link to="/products?category=more">more</Link>
        </li>
  
      </ul>
      <Modal open={openModal} setOpen={setOpenModal}>
        <div>
          <h1 className="text-gray-800 text-3xl">
            Are you sure you want to Logout?
          </h1>
          <div className="flex items-center justify-center gap-4 mt-3">
            <button onClick={handleLogout} className="btn btn-primary px-8">
              Log out
            </button>
            <button
              onClick={() => setOpenModal(false)}
              className="btn btn-ghost px-8 text-gray-600"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
